import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenDialogBox } from '../reducers/global-reducer';
import { ReactComponent as EditIcon } from '../assets/Images/EditImage.svg'
import BusinessIcon from '@mui/icons-material/Business';
import { useMediaQuery } from "@mui/material";
import { useTranslate } from 'react-redux-multilingual';

const image1 = {
  width: '150px',
  height: '150px',
  position: 'relative'
}

const image2 = {
  width: '100px',
  height: '100px',
}

const imagePos1 = {
  position: 'absolute',
  top: '8.6rem',
  left: '12rem'
}

const imagePos2 = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  margin: '0.5rem 0 -1rem 0',
  top: '2rem'
}

const editIcon = {
  fontSize: '30px',
  zIndex: '100',
  marginLeft: '-34px',
  width: "1.5rem",
  height: "1.5rem"
}

const editIcon2 = {
  fontSize: '30px',
  position: 'absolute',
  top: '0px',
  right: '29px',
  width: "1.5rem",
  height: "1.5rem"
}

const uploadProfilePicText1 = {
  position: 'absolute',
  fontSize: '12px',
  top: '150px',
  // left: '20px'
}
const marfin1 = {
  margin: '1rem -3.75rem 0 0px'
}
const marfin2 = {
  margin: '3rem -3.75rem 0 0px'
}

const uploadProfilePicText2 = {
  position: 'absolute',
  fontSize: '12px',
  top: '60px'
}

export default function ImageAvatars({ route, srcFile }) {

  const dispatch = useDispatch();

  const t = useTranslate();

  const store = useSelector(state => state);

  const matches = useMediaQuery('(min-width:1245px)');

  const { currentScreen } = store.globalreducer;

  const handleOpen = () => {
    if (route === "existingUser") return
    dispatch(setOpenDialogBox(true))
  }

  return (
    <div style={matches ? imagePos1 : imagePos2}>
      {
        (currentScreen === 2 && srcFile === "") ?
          <div onClick={handleOpen} style={{ width: `${matches ? 150 : 100}`, height: `${matches ? 150 : 100}`, margin: '5px', border: '1px solid grey', borderRadius: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: `${matches ? '42px' : '16px'}` }}>
            <BusinessIcon sx={{ width: '32px', height: '32px' }} />
          </div>
          :
          currentScreen === 2 ?
            <Avatar onClick={handleOpen} sx={matches ? image1 : image2} alt="Remy Sharp" src={srcFile} />
            :
            <Avatar onClick={handleOpen} sx={matches ? image1 : image2} alt="Remy Sharp" src={srcFile} />
      }
      <EditIcon onClick={handleOpen} style={matches ? editIcon2 : editIcon} />
      <Typography style={matches ? marfin1 : marfin2} variant='small' sx={matches ? uploadProfilePicText1 : uploadProfilePicText2}>{currentScreen === 1 ? t('uploadprofilepic') : t('uploadcompanylogo')}</Typography>
    </div>
  );
}
